<template>
    <div>
        <div ref="sticky" :style="{ top }" aria-hidden="true" class="sticky-header-wrapper">
            <slot />
        </div>
        <div ref="orig" class="sticky-header-orig">
            <slot />
        </div>
    </div>
</template>

<script setup>
import { onMounted, onUnmounted, useTemplateRef } from 'vue';
import useStickyTop from '@/composables/useStickyTop';

const top = useStickyTop();
const originalElement = useTemplateRef('orig');
const stickyElement = useTemplateRef('sticky');

const onScrollSticky = (event) => {
    let el = originalElement.value?.getElementsByClassName('table-responsive')?.[0];

    if (el) {
        el.scrollLeft = event.target.scrollLeft;
    }
};
const onScrollEl = (event) => {
    let el = stickyElement.value?.getElementsByClassName('table-responsive')?.[0];

    if (el) {
        el.scrollLeft = event.target.scrollLeft;
    }
};

onMounted(() => {
    const el = originalElement.value?.getElementsByClassName('table-responsive')?.[0];
    const sticky = stickyElement.value?.getElementsByClassName('table-responsive')?.[0];

    el?.addEventListener('scroll', onScrollEl);
    sticky?.addEventListener('scroll', onScrollSticky);
});

onUnmounted(() => {
    const el = originalElement.value?.getElementsByClassName('table-responsive')?.[0];
    const sticky = stickyElement.value?.getElementsByClassName('table-responsive')?.[0];

    el?.removeEventListener('scroll', onScrollSticky);
    sticky?.removeEventListener('scroll', onScrollEl);
});
</script>

<style scoped>
.sticky-header-wrapper {
    position: sticky;
    top: 61px;
    border-top: 4px solid var(--c-table-border-color);
    overflow: hidden;
    height: 48px;
    z-index: 1;
}

@media (max-width: 576px) {
    .sticky-header-wrapper {
        top: 61px !important;
    }
}

.card-body .sticky-header-wrapper {
    border-top-color: #fff;
}

.sticky-header-orig {
    margin-top: -48px;
}

/* The sticky clone duplicates the whole table but only ever shows the header
   (clipped to 48px). Its body rows stay in the DOM, and Safari's Find-on-Page
   will scroll them into the sticky band — "promoting" a matched row so it
   appears twice. Find ignores visibility:hidden (unlike overflow:hidden), so
   hiding the clone's body keeps column widths aligned while making it
   unsearchable. */
.sticky-header-wrapper :slotted(tbody) {
    visibility: hidden;
}
</style>
